import { useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { FiAlertCircle } from 'react-icons/fi'

import { Modal } from 'Components/Ui'
import { Button, TextInput } from 'Components/Form'

export default function ConfirmationModal({
    children,
    data,
    onConfirm,
    title = '',
    message = '',
    className = '',
    maxWidth = 'md',
}) {
    const [confirming, setConfirming] = useState(false)
    const [datas, setData] = useState(data ?? {})
    const sigCanvas = useRef()

    const handleChange = (name, value) => setData({ ...datas, [name]: value })
    const closeModal = () => setConfirming(false)

    const handleOpen = () => {
        setConfirming(true)
        if ('signature' in datas) {
            setTimeout(() => {
                sigCanvas.current.clear()
                sigCanvas.current.fromDataURL(data.signature, { width: 500, height: 200 })
                handleChange('signature', data.signature)
            }, 100)
        }
    }

    return (
        <div>
            <button type="button" className={className} onClick={handleOpen}>
                {children}
            </button>
            <Modal show={confirming} onClose={closeModal} maxWidth={maxWidth}>
                <div className="grid gap-3 p-6 text-center">
                    <span className="inline-block mx-auto">
                        <div className="flex items-center justify-center w-20 h-20 transition rounded-full bg-warning/10 text-warning">
                            <FiAlertCircle size={40} />
                        </div>
                    </span>
                    <h3 className="text-xl font-bold text-black dark:text-white sm:text-2xl">{title || 'Confirmation Alert!'}</h3>
                    <p className="text-sm">{message || 'Are you sure you want to change status?'}</p>
                    {'signature' in datas && (
                        <SignatureCanvas
                            ref={sigCanvas}
                            canvasProps={{ width: 500, height: 200, className: 'border' }}
                            onEnd={() => handleChange('signature', sigCanvas.current.toDataURL('image/png'))}
                        />
                    )}
                    {'remarks' in datas && (
                        <div className="flex flex-col gap-3 text-left">
                            <TextInput
                                as="textarea"
                                id="remarks"
                                name="remarks"
                                label="Remarks"
                                value={datas.remarks ?? ''}
                                onChange={e => handleChange('remarks', e.target.value)}
                            />
                        </div>
                    )}
                    <div className={`grid grid-cols-1 gap-3 pt-5 ${'signature' in datas ? 'md:grid-cols-3' : 'md:grid-cols-2'}`}>
                        {'signature' in datas && (
                            <Button
                                className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                onClick={() => {
                                    sigCanvas.current.clear()
                                    handleChange('signature', null)
                                }}
                                type="button"
                            >
                                Clear
                            </Button>
                        )}
                        <Button type="button" className="w-full text-white border-danger bg-danger" onClick={closeModal}>
                            No
                        </Button>
                        <Button
                            className="w-full text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                            onClick={() => {
                                closeModal()
                                onConfirm(datas)
                            }}
                        >
                            Yes
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
